import React from 'react'

import * as S from './styles'

const DatePicker: React.FC<any> = ({
  onFrom,
  onTo,
  from,
  to,
  disabled,
}: any) => {
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    setState: React.Dispatch<React.SetStateAction<string>>,
  ) => {
    setState(event.target.value)
  }

  return (
    <S.Container>
      <S.InputContainer>
        <S.Label>de</S.Label>
        <S.Input
          disabled={disabled}
          type="date"
          value={from}
          onChange={(event) => handleChange(event, onFrom)}
        />
      </S.InputContainer>
      <S.InputContainer>
        <S.Label>até</S.Label>
        <S.Input
          disabled={disabled}
          type="date"
          value={to}
          onChange={(event) => handleChange(event, onTo)}
        />
      </S.InputContainer>
    </S.Container>
  )
}

export default DatePicker
